import React from "react";

export const Button = ({
  children,
  onClick,
  disabled,
  className = "",
  variant = "default",
  size = "default",
  type,
}) => {
  const sizeStyles = {
    default: "px-4 py-2 text-sm",
    sm: "px-3 py-1.5 text-xs",
  };

  const baseStyles = `inline-flex items-center justify-center rounded font-medium transition-colors disabled:opacity-50 ${sizeStyles[size] || sizeStyles.default}`;

  const variantStyles = {
    default: "bg-blue-500 hover:bg-blue-600 text-white",
    outline:
      "border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200",
    secondary:
      "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200",
    ghost:
      "hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200",
    destructive: "bg-red-600 hover:bg-red-700 text-white",
  };

  const styles = `${baseStyles} ${variantStyles[variant] || variantStyles.default} ${className}`;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={styles}
    >
      {children}
    </button>
  );
};
